export interface FormFieldData {
  value: any
  errors?: Error[]
}

export type FormData = Record<string, FormFieldData>

export default (errors: Record<string, any> = {}, values: Record<string, any> = {}): FormData => {
  const filedsData: FormData = {}

  for (const error in errors) {
    if (Array.isArray(errors[error])) {
      filedsData[error] = {
        value: values[error],
        errors: errors[error].map((e: string) => new Error(e))
      }
    }
  }

  return filedsData
}
